// Paramètres d'URL des référentiels (REF-P02, REF-P05) : sélection partageable, analyse légère (module chargé par le
// routeur au démarrage, budget JS initial).
import { parseListSearch, type ListSearch } from '@/lib/list-query';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const id = (value: unknown): string | undefined => (typeof value === 'string' && UUID.test(value) ? value : undefined);

const text = (value: unknown, max = 120): string | undefined => {
  const raw = typeof value === 'number' && Number.isFinite(value) ? String(value) : value;
  return typeof raw === 'string' && raw.trim() !== '' ? raw.slice(0, max) : undefined;
};

/** REF-P02 : localités sélectionnées dans chaque colonne et recherche globale. */
export interface LocalitySearch {
  region?: string;
  province?: string;
  commune?: string;
  village?: string;
  q?: string;
}

export function parseLocalitySearch(raw: Record<string, unknown>): LocalitySearch {
  const search: LocalitySearch = {};
  const region = id(raw.region);
  const province = region ? id(raw.province) : undefined;
  const commune = province ? id(raw.commune) : undefined;
  const village = commune ? id(raw.village) : undefined;
  const q = text(raw.q);
  if (region) search.region = region;
  if (province) search.province = province;
  if (commune) search.commune = commune;
  if (village) search.village = village;
  if (q) search.q = q;
  return search;
}

/** REF-P05 : onglet actif et page de l'historique. */
export interface ReferentialDetailSearch extends ListSearch {
  onglet?: string;
}

export function parseReferentialDetailSearch(raw: Record<string, unknown>): ReferentialDetailSearch {
  const onglet = text(raw.onglet, 20);
  return { ...parseListSearch(raw), ...(onglet ? { onglet } : {}) };
}
